export var ActivityPointType;
(function (ActivityPointType) {
    ActivityPointType["VIDEO_CALL"] = "VIDEO_CALL";
    ActivityPointType["TRAINING_SESSION"] = "TRAINING_SESSION";
    ActivityPointType["DIAGNOSIS"] = "DIAGNOSIS";
    ActivityPointType["ONBOARDING_COMPLETED"] = "ONBOARDING_COMPLETED";
    ActivityPointType["PROFILE_COMPLETED"] = "PROFILE_COMPLETED";
})(ActivityPointType || (ActivityPointType = {}));
//# sourceMappingURL=activity-point-type.js.map